<header class="modern-navbar">
    <!-- Top Bar avec Informations de Contact -->
    <div class="top-bar">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-8 col-md-12">
                    <div class="contact-info">
                        <div class="contact-item">
                            <i class="icofont-location-pin"></i>
                            <span>
                                <strong>Guinée - Conakry</strong>
                                <br/>
                                {{ appSettingService.value.address }}
                            </span>
                        </div>
                        <div class="contact-item">
                            <i class="icofont-phone"></i>
                            <span>
                                <strong>+224 {{ appSettingService.value.phone_number2 }}</strong>
                                <br/>
                                Appelez-nous
                            </span>
                        </div>
                        <div class="contact-item">
                            <i class="icofont-email"></i>
                            <span>
                                <strong>{{ appSettingService.value.email }}</strong>
                                <br/>
                                Contactez-nous
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-12">
                    <div class="top-actions">
                        <div class="social-links">
                            <a [href]="appSettingService.value.facebook_url" title="Facebook" target="_blank" class="social-link">
                                <i class="icofont-facebook"></i>
                            </a>
                            <a [href]="appSettingService.value.youtube_url" title="Youtube" target="_blank" class="social-link">
                                <i class="icofont-youtube-play"></i>
                            </a>
                            <a [href]="appSettingService.value.twiter_url" title="Twitter" target="_blank" class="social-link">
                                <i class="icofont-twitter"></i>
                            </a>
                            <a [href]="appSettingService.value.instagram_url" title="Instagram" target="_blank" class="social-link">
                                <i class="icofont-instagram"></i>
                            </a>
                        </div>
                        <div class="auth-buttons">
                            <a *ngIf="!companyService.isAuthenticated()" routerLink="/choose-login" class="btn-login">
                                Connexion
                            </a>
                            <a *ngIf="!companyService.isAuthenticated()" routerLink="/create-account" class="btn-register">
                                S'enregistrer
                            </a>
                            <a style="cursor: pointer;" *ngIf="companyService.isAuthenticated()" (click)="logout()" class="btn-register">
                                Déconnexion
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Main Navigation -->
    <nav class="main-navbar">
        <div class="container">
            <div class="navbar-wrapper">
                <!-- Logo -->
                <div class="navbar-brand">
                    <a routerLink="/" class="logo-link">
                        <img [src]="appSettingService.value.logo" alt="BSTP Logo" class="logo-img">
                    </a>
                </div>

                <!-- Mobile Menu Toggle -->
                <div class="mobile-toggle" (click)="toggleMobileMenu()">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                <!-- Navigation Menu -->
                <div class="navbar-menu" [class.active]="isMobileMenuOpen">
                    <ul class="nav-menu">
                        <li class="nav-item">
                            <a routerLink="/" 
                               class="nav-link" 
                               routerLinkActive="active"
                               [routerLinkActiveOptions]="{ exact: true }"
                               (click)="closeMobileMenu()">
                                ACCUEIL
                            </a>
                        </li>

                        <li class="nav-item">
                            <a routerLink="/about" 
                               class="nav-link" 
                               routerLinkActive="active"
                               [routerLinkActiveOptions]="{ exact: true }"
                               (click)="closeMobileMenu()">
                                A PROPOS DE NOUS
                            </a>
                        </li>
                        <li class="nav-item">
                            <a routerLink="/missions" 
                               class="nav-link" 
                               routerLinkActive="active"
                               [routerLinkActiveOptions]="{ exact: true }"
                               (click)="closeMobileMenu()">
                                NOS MISSIONS
                            </a>
                        </li>
                        <li class="nav-item">
                            <a routerLink="/contact" 
                               class="nav-link" 
                               routerLinkActive="active"
                               [routerLinkActiveOptions]="{ exact: true }"
                               (click)="closeMobileMenu()">
                                CONTACTEZ-NOUS
                            </a>
                        </li>
                        <li *ngIf="companyService.isAuthenticated()" class="nav-item">
                            <a routerLink="/company/dashboard" 
                               class="nav-link" 
                               routerLinkActive="active"
                               [routerLinkActiveOptions]="{ exact: true }"
                               (click)="closeMobileMenu()">
                                TABLEAU DE BORD
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </nav>
</header>
